import React, { Component } from 'react';
import moment from 'moment-timezone';
import CrewIssuesIcon from '../../../assets/images/delays/CrewIssues.svg';
import DamagedEquipmentIcon from '../../../assets/images/delays/DamagedEquipment.svg';
import DependencyIcon from '../../../assets/images/delays/Dependency.svg';
import MissingEquipmentIcon from '../../../assets/images/delays/MissingEquipment.svg';
import NatureIcon from '../../../assets/images/delays/Nature.svg';
import RoadIcon from '../../../assets/images/delays/Road.svg';
import SiteAccessIcon from '../../../assets/images/delays/SiteAccess.svg';
import WeatherIcon from '../../../assets/images/delays/Weather.svg';
import OtherIcon from '../../../assets/images/delays/Other.svg';
import './DelayCard.scss';

export class DelayCard extends Component {

  constructor(props) {
    super(props);
    this.mapTypeToIcon = this.mapTypeToIcon.bind(this);
    this.handleViewDelay = this.handleViewDelay.bind(this);
  }

  mapTypeToIcon(delayType) {
    switch (delayType) {
    case 'crew_issues':
      return CrewIssuesIcon;
    case 'damaged_equipment':
      return DamagedEquipmentIcon;
    case 'dependency':
      return DependencyIcon;
    case 'missing_equipment':
      return MissingEquipmentIcon;
    case 'nature':
      return NatureIcon;
    case 'road':
      return RoadIcon;
    case 'site_access':
      return SiteAccessIcon;
    case 'weather':
      return WeatherIcon;
    case 'other':
      return OtherIcon;
    default:
      return OtherIcon;
    }
  }

  handleViewDelay(e) {
    e.stopPropagation();
    if (this.props.viewDelay) {
      this.props.viewDelay(this.props.delay, this.mapTypeToIcon(this.props.delay.delay_type));
    }
  }

  render() {
    const { delay } = this.props;
    if (!delay){
      return null;
    }
    const timeZone = moment.tz.guess();
    const icon = this.mapTypeToIcon(delay.delay_type);
    const createDate = moment.tz(delay.created_at, timeZone).format('MM/DD/YYYY');
    const createTime = moment.tz(delay.created_at, timeZone).format('h:mm A z');
    return (
      <div className={'delay-card' + (this.props.animate ? ' fade-in': '')}
        onClick={this.handleViewDelay}>
        <div className="delay-type-icon-background">
          <img className="delay-type-icon" src={icon} alt={delay.delay_type} />
        </div>
        <div className="delay-description">
          <div className="delay-name">{delay.name ? delay.name.toUpperCase() : ''}</div>
          <div className="delay-date-time">{createTime + ' ' + createDate}</div>
        </div>
        <div className="delay-arrow"></div>
      </div>);
  }
}
export default (DelayCard);



// WEBPACK FOOTER //
// ./src/components/DelaysContainer/DelayCard/index.js